module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.eot?af9a28e7f261a412f581250bed062240";